/*
 * @Author: Christion.Young
 * @Date: 2021-09-17 10:04:22
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-08-14 15:20:00
 * @Description: API统一入口 - 使用新的统一API
 */

// 导入新的统一API
import API, {
  authAPI,
  platformAPI,
  serviceAPI,
  merchantAPI,
  userAPI,
  noPermissionRequired,
} from "./api.js";

// 推荐使用的新API导出
export { authAPI, platformAPI, serviceAPI, merchantAPI, userAPI };

// 统一API对象 - 推荐使用
export default API;

// 兼容性导出
export { noPermissionRequired };
